import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import CommentUrl from './commentUrl';
import Vote from './vote';
import ShareIconBox from './shareIconBox';
import errorBoundary from '@ifeng/errorBoundary';
import { getCommentCount } from '../../../../../services/api';
import Ppx from '../../../components/ppx';

class ShareBox extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
        logoPPX: PropTypes.string,
    };

    state = {
        allowComment: false,
    };

    async componentDidMount() {
        const { commentUrl } = this.props.docData;

        try {
            const { allow_comment } = await getCommentCount(commentUrl);

            this.setState({
                allowComment: allow_comment !== -1,
            });
        } catch (e) {
            console.error(e);
        }
    }

    /**
     * 渲染网页布局
     */
    render() {
        const { allowComment } = this.state;
        const { docData, logoPPX } = this.props;
        const { title, summary, commentUrl, imagesInContent } = docData;

        return (
            <div>
                <ul className={styles.mod_share}>
                    {logoPPX ? (
                        <Chip id="25031" type="static" title="泡泡直播" groupName="头部" user="dev" content={logoPPX}>
                            <Ppx />
                        </Chip>
                    ) : (
                        ''
                    )}
                    {allowComment && (
                        <React.Fragment>
                            <li className={styles.line01} />
                            <CommentUrl docData={docData} />
                        </React.Fragment>
                    )}
                    <li className={styles.line01} />
                    <ShareIconBox docData={docData} />
                    <li className={styles.line01} />
                    <Vote docData={docData} url={commentUrl} />
                </ul>
            </div>
        );
    }
}

export default errorBoundary(ShareBox);
